import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import MediaUploader from "./MediaUploader";
export default function DialogPopup({
  // open,
  // handleClose,
  // handleClickOpen,
  questionIndex,
  answerIndex,
  onMediaUpdate,
  media,
  disabled,
  bookId,
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button color="success" variant="outlined" onClick={handleClickOpen}>
        {media ? "update media" : "add media"}
      </Button>
      {open && (
        <Dialog
          className="nodrag"
          fullWidth
          maxWidth={"lg"}
          open={open}
          onClose={handleClose}
        >
          <DialogTitle></DialogTitle>
          <DialogContent>
            <MediaUploader
              questionIndex={questionIndex}
              answerIndex={answerIndex}
              disabled={disabled}
              media={media} // filter by current language
              onMediaUpdate={onMediaUpdate}
              bookId={bookId}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
